const edit = {
  path: 'edit',
  component: resolve => require(['@/pages/admin/merchant/edit'], resolve),
  meta: {
    requireAuth: true
  }
}

export default edit
